import React, { Component } from "react";
import { HashRouter, Route, Switch, Redirect } from "react-router-dom";
import "./scss/style.scss";
import Success from "./views/pages/register/Success";

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
);

// Containers
const TheLayout = React.lazy(() => import("./containers/TheLayout"));

// Pages
const Login = React.lazy(() => import("./views/pages/login/Login"));
const Register = React.lazy(() => import("./views/pages/register/Register"));
const Page404 = React.lazy(() => import("./views/pages/page404/Page404"));
const Page500 = React.lazy(() => import("./views/pages/page500/Page500"));
//const Dashboard = React.lazy(() => import("./views/dashboard/Dashboard"));

const isAuthenticated = () => {

  const user = JSON.parse(sessionStorage.getItem("user"));
  if (user) {
    if (user.accessToken) {
      return true;
    } else {
      return false;
    }
  }

};

const UnauthenticatedRoute = ({ component: Component, ...rest }) => (

  <Route
    {...rest}
    render={(props) =>
      !isAuthenticated() ? <Component {...props} /> : <Redirect to="/" />
    }
  />
);

const AuthenticatedRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      isAuthenticated() ? <Component {...props} /> : <Redirect to="/Login" />
    }
  />
);

class App extends Component {
  // setUser = user => {
  // this.setState({ user: user });
  // this.setState({ jwt: user.idToken.jwtToken });
  // global.token = user.idToken.jwtToken;
  //console.log(user.idToken.jwtToken)
  //console.log(user.idToken)
  //console.log(user.accessToken.payload["cognito:groups"])

  //}

  // constructor(props) {
  //   super(props);
  //   // this.state = {
  //   //   user: [],
  //   //   jwt: "",
  //   // };
  // }
  componentDidMount() { }

  render() {
    // const authProps = {
    //   user: this.state.user,
    //   setUser: this.setUser,
    // };

    return (
      <HashRouter>
        <React.Suspense fallback={loading}>
          <Switch>
            <UnauthenticatedRoute
              exact
              path="/login"
              name="Login Page"
              component={Login}
            />
            <UnauthenticatedRoute
              exact
              path="/success"
              name="Login Page"
              component={Success}
            />
            {/* <Route
              exact
              path="/Login"
              name="Login Page"
              render={(props) => <Login {...props} auth={authProps} />}
            />
            <Route
              exact
              path="/register"
              name="Register Page"
              render={(props) => <Register {...props} />}
            />
            <Route
              exact
              path="/404"
              name="Page 404"
              render={(props) => <Page404 {...props} />}
            />
            <Route
              exact
              path="/500"
              name="Page 500"
              render={(props) => <Page500 {...props} />}
            />
            <Route
              path="/"
              name="Home"
              render={(props) => <TheLayout {...props} />}
            />
            <Route
              path="/dashboard"
              name="Dashboard"
              render={(props) => <Dashboard {...props} />}
            /> */}

            {/* <UnauthenticatedRoute exact path="/login" name="Login Page" component={Login} /> */}
            <Route exact path="/register" name="Register Page" component={Register} />
            <Route exact path="/404" name="Page 404" component={Page404} />
            <Route exact path="/500" name="Page 500" component={Page500} />
            <AuthenticatedRoute path="/" name="Home" component={TheLayout} />
            {/* <AuthenticatedRoute path="/" name="Home" component={Dashboard} /> */}
          </Switch>
        </React.Suspense>
      </HashRouter>
    );
  }
}

export default App;
